import React, { memo } from 'react';

import JiraTopBanner from '@post-office-placement/jira-top-banner/placement';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { PostOfficeProvider } from '@atlassian/jira-post-office-provider/src/index.tsx';
import { PlacementFetchProvider } from '@atlassian/jira-post-office-provider/src/placement-fetch-provider.tsx';
import killswitch from '@atlassian/jira-killswitch/src/index.tsx';
import { postOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';

import { Placement } from '@atlassian/post-office-placement';
import { useResource } from '@atlassian/react-resource-router';

const PLACEMENT_ID = 'jira-top-banner';

const TopBannerPlacement = () => {
	if (__SERVER__) {
		// do not remove server check before MAGMA-4227 is resolved: https://atlassian.slack.com/archives/C0288U06PGC/p1758676723058979?thread_ts=1755502530.582239&cid=C0288U06PGC
		return null;
	}
	return (
		<JSErrorBoundary
			id="topBannerPlacement"
			packageName="top-banner-placement"
			teamName="post-office"
			fallback={() => <></>}
		>
			<PostOfficeProvider>
				<div data-testid="top-banner-placement.jira-top-banner-placement">
					<PlacementFetchProvider resource={postOfficeJiraTopBannerResource}>
						<Placement
							placementId={PLACEMENT_ID}
							// Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
							PlacementComponent={JiraTopBanner}
						/>
					</PlacementFetchProvider>
				</div>
			</PostOfficeProvider>
		</JSErrorBoundary>
	);
};

export const JiraTopBannerPlacement: React.MemoExoticComponent<() => React.JSX.Element | null> =
	memo((): React.JSX.Element | null => {
		if (__SERVER__) {
			// do not remove server check before MAGMA-4227 is resolved: https://atlassian.slack.com/archives/C0288U06PGC/p1758676723058979?thread_ts=1755502530.582239&cid=C0288U06PGC
			return fg('jira-issue-term-refresh-banner') ? <ServerPlacementAPIFetchEnabled /> : null;
		}

		if (!killswitch('killswitch_post_office_in_jira') && fg('jira-issue-term-refresh-banner')) {
			return <TopBannerPlacement />;
		}

		return null;
	});

const ServerPlacementAPIFetchEnabled = () => {
	// FIXME: this isn't how useResource works... this can just be removed - comment below preserved for history
	// Use resource to make the shadow API call to Post Office.
	// Don't do anything with the result, we just want to mock the traffic for now.
	useResource(postOfficeJiraTopBannerResource);

	return null;
};
